import { Reducer } from 'redux';

import { MandantConfigState } from './MandantConfigState';
import {
  MANDANT_CONFIG_DATA,
  MANDANT_CONFIG_LOADING,
  MANDANT_CONFIG_TRANSLATION,
  MANDANT_CONFIG_LOGO_FOUND,
} from './actions';

const INITIAL_STATE: MandantConfigState = {
  loading: false,
  data: null,
  loaded: false,
  translation: [],
  logoFound: null,
};

export const MandantConfigReducer: Reducer<MandantConfigState> = (
  state = INITIAL_STATE,
  { type, payload },
) => {
  switch (type) {
    case MANDANT_CONFIG_LOADING:
      return {
        ...state,
        loading: payload.loading,
      };
    case MANDANT_CONFIG_DATA:
      return {
        ...state,
        loaded: !!payload.data,
        data: payload.data,
      };
    case MANDANT_CONFIG_TRANSLATION:
      return {
        ...state,
        translation: payload,
      };
    case MANDANT_CONFIG_LOGO_FOUND:
      return {
        ...state,
        logoFound: payload.logoFound,
      };
    default:
      return state;
  }
};
